export default __webpack_public_path__ + "static/media/plans-active.0986a507.svg";